import { FunctionComponent, useEffect, useState } from 'react';
import styles from './RetriggerWebhookDialogue.module.scss';

import { Box, Modal } from 'vopay';

import RetriggerWebhookDialogueForm from './RetriggerWebhookDialogueForm';
import { UpdateWebhooksHandler } from '../UpdateWebhooks/types';

type RetriggerWebhookDialogueProps = {
  title: string | React.JSX.Element;
  variant: 'webhook-retrigger';
  isVisible: boolean;
  closeModal: () => void;
  webhookEventType: { id: string; label: string };
  handlers: UpdateWebhooksHandler;
};

type FC = FunctionComponent<RetriggerWebhookDialogueProps>;

const RetriggerWebhookDialogue: FC = (props: RetriggerWebhookDialogueProps) => {
  const { title, variant, isVisible, closeModal, webhookEventType, handlers } = props;
  const [defaultValues, setDefaultValues] = useState({
    EventID: '',
    Type: '',
  });

  useEffect(() => {
    setDefaultValues;
  }, []);

  return (
    <>
      <Modal isVisible={isVisible} enableBgClick={false}>
        <div className={styles.container}>
          <Box flx="col" ai="center">
            <div className={styles.TitleContainer}>
              <h1>{title}</h1>
            </div>
            <Box flx="col" jc="fs" ai="center">
              Refer to the ID included in the payload for {webhookEventType.label}
            </Box>
            <Box pt="md">
              <RetriggerWebhookDialogueForm
                webhookEventType={webhookEventType}
                defaultValues={defaultValues}
                variant={variant}
                handlers={handlers}
                closeModal={closeModal}
              />
            </Box>
          </Box>
        </div>
      </Modal>
    </>
  );
};

export default RetriggerWebhookDialogue;
